import * as types from "../constants/actionTypes";
import * as IDTypes from "../constants/PatientIDTypes";
import * as tools from "../helpers/Tools";
import * as features from "../constants/MembershipFeatures";

export const membershipInitialState = {
    isError: false,
    isLoading: false,
    membershipData: null,
    featureRX: false,
    hasMyChartAccount: false,
    myChartID: null,
    hasProfileData: false,
    profileList: null,
    activeProfile: null,
    activeProfileIndex: null,
    logins: null, // we carry over token logins here to short circuit some membership switches (thrive and healthplan)
    proxyList: null,
    proxyListLoading: false,
    primaryUser: null,
    currentUser: null,
    proxyListFailure: false,
    proxyListLoaded: true,
    switchingProxyUser: false,
    switchUserPayload: null,
    eVisitsFromProxy: null,
    currentUserEVisit: null,
    isProxySwitchForMychartDeepLink: false,
    isProxyFound: false,
    membershipBranding: {
        insuranceLogo: '',
        insuranceLogoAltText: '',
        insuranceLogoClass: ''
    },
    isActiveFeatureAnyone_InHomeVaccine: false,
    ...getDefaultStateForFeatures(),

};

/**
 * @returns {object} the AuthorizedFeatures array as an object
 */
export function getEpicAuthorizedFeatures(epic) {
    const authorizedFeatures = epic && epic.patient && epic.patient.AuthorizedFeatures;
    if (!authorizedFeatures || authorizedFeatures.length === 0) {
        return null;
    }
    const epicAuthorizedFeatures = {};
    authorizedFeatures.forEach(feature => epicAuthorizedFeatures[feature] = true);
    return epicAuthorizedFeatures;
}

export function enableCareCompanion(authorizedFeatures) {
    if (!authorizedFeatures) {
        return false;
    }

    const careCompanionAuthorizedFeatures = window.serverData && window.serverData.data && window.serverData.data.careCompanionAuthorizedFeatures;
    if (!careCompanionAuthorizedFeatures) {
        return true;
    }

    const list = careCompanionAuthorizedFeatures.split('|');
    for (let i = 0; list.length; i++) {
        if (authorizedFeatures[list[i]]) {
            return true;
        }
    }
    return false;
}

export default function membershipReducer(state = membershipInitialState, action) {
    try {
        switch (action.type) {
            case types.MEMBERSHIP_GET_FAILURE:
                return {
                    ...state,
                    isError: true,
                    isLoading: false,
                    membershipData: null,
                    featureRX: false,
                    hasMyChartAccount: false,
                    myChartID: null,
                    proxyListFailure: true,
                    ...getDefaultStateForFeatures()
                };
            case types.USER_AUTHENTICATE_SUCCESS:
                var oNewProps;
                if (state.activeProfile || state.profileList) {
                    var currProfile = state.activeProfile;
                    var activeProfileIndex = state.activeProfileIndex;
                    if (currProfile === undefined || currProfile == null) {
                        currProfile = profileList.length > 0 ? profileList[0] : null;
                        activeProfileIndex = currProfile ? 0 : null;
                    }
                    oNewProps = getStateFromFeatures(
                        action.userData.Logins,
                        currProfile);
                }
                return {
                    ...state,
                    ...oNewProps,
                    activeProfileIndex,
                    logins: action.userData.Logins,

                };
            case types.MEMBERSHIP_GET_START:
                return {
                    ...state, proxyListLoading: true, proxyListFailure: false, proxyListLoaded: false,
                }
            case types.MEMBERSHIP_GET_SUCCESS:
                try {
                    var profileList = tools.getProfileListFromMembershipData(action.data);
                    let activeProfileIndex = state.activeProfileIndex;
                    let currProfile = null;
                    if (activeProfileIndex >= 0) {
                        currProfile = profileList[state.activeProfileIndex];
                    }
                    if (currProfile === undefined || currProfile == null) {
                        currProfile = profileList.length > 0 ? profileList[0] : null;
                        activeProfileIndex = currProfile ? 0 : null
                    }
                    let oNewProps;
                    if (state.logins !== null) {
                        oNewProps = getStateFromFeatures(
                            state.logins,
                            currProfile);
                    }
                    const oBrandingData = getBrandingData(currProfile, state);
                    const anyProxyHasInHome = profileList.find((prof) => { return tools.getFeature(prof, features.InHomeVaccine) })

                    let currPrimUser = state.primaryUser;

                    // Overwrite existing proxy list
                    var newProxyList = tools.convertProfileListToProxyList(profileList);
                    if (!currPrimUser) {
                        currPrimUser = newProxyList && newProxyList.length > 0 ? newProxyList[0] : null;
                    }
                    let currCurrentUser = state.currentUser;
                    if (!currCurrentUser) {
                        currCurrentUser = currPrimUser;
                    }
                    const epicAuthorizedFeatures = getEpicAuthorizedFeatures(action.data.epic);
                    var oRet = {
                        ...state,
                        isError: false,
                        isLoading: false,
                        membershipData: action.data,
                        membershipBranding: oBrandingData,
                        hasMyChartAccount: tools.hasMyChart(action.data),
                        myChartID: tools.getMyChartID(action.data),
                        hasProfileData: true,
                        profileList: profileList,
                        activeProfile: currProfile,
                        activeProfileIndex,
                        proxyList: newProxyList,
                        primaryUser: currPrimUser,
                        currentUser: currCurrentUser,
                        isProxyFound: newProxyList && newProxyList.length > 1 ? true : false,
                        proxyListLoading: false,
                        proxyListFailure: false,
                        proxyListLoaded: true,
                        isActiveFeatureAnyone_InHomeVaccine: !!anyProxyHasInHome,
                        epicAuthorizedFeatures,
                        //enableCareCompanion: enableCareCompanion(epicAuthorizedFeatures),
                        ...oNewProps,
                    };
                    return oRet;
                }
                catch (ex) {
                    console.error("types.MEMBERSHIP_GET_SUCCESS", ex);
                    //debugger;
                    throw ex;
                }
            case types.MEMBERSHIP_CARE_COMPANION:
                return { ...state, enableCareCompanion: action.enabled };
            case types.RESET_USER_VALUE:
                return { ...state, currentUser: null, primaryUser: null };

            case types.SWITCH_USER_SAGA:
                return { ...state, switchingProxyUser: true, switchUserPayload: action };

            case types.SWITCH_USER_REDUCER:
                // don't like doing this, but faster than reducing the same list into multiple reducers
                // ultimately we should collapse these reducers
                try {
                    if (state.profileList) {
                        const currProfile = state.profileList[action.index];

                        let oNewProps = getStateFromFeatures(
                            state.logins,
                            currProfile);
                        const user = {
                            ...action.user
                        };


                        const currentUserEVisit = state.eVisitsFromProxy?.find((e) => {
                            return e.externalId === user.externalId
                        })
                        let oRet = {
                            ...state,
                            ...oNewProps,
                            activeProfile: currProfile,
                            activeProfileIndex: action.index,
                            currentUser: user,
                            zipnosis: null,
                            switchingProxyUser: false,
                            currentUserEVisit,
                            switchUserPayload: null
                        };
                        return oRet;
                    }
                    else {
                        return { ...state };
                    }
                }
                catch (ex) {
                    console.error("types.SWITCH_USER_REDUCER", ex);
                    throw ex;
                }

            case types.LOGOUT_COMPLETED:
                return membershipInitialState;
            case types.USER_AUTHENTICATE:
            case types.USER_AUTHENTICATE_FAILURE:
                return {
                    ...state,
                    proxyList: null
                };
            case types.EVISIT_GET_SUCCESS:
                const currentUserEVisit = action.eVisit.find((e) => {
                    if (state.currentUser) {
                        return e.externalId === state.currentUser.externalId
                    }
                    return null;
                })
                return { ...state, eVisitsFromProxy: action.eVisit, currentUserEVisit: currentUserEVisit, proxyListFailure: false };
            case types.EVISIT_GET_FAILURE:
                return { ...state, eVisitsFromProxy: action.eVisit, proxyListFailure: true };

            case types.IS_PROXY_SWITCH_FOR_MYCHART_DEEPLINK:
                return { ...state, isProxySwitchForMychartDeepLink: action.isProxySwitchForMychartDeepLink };

            default:
                return { ...state };
        }
    }
    catch (Ex) {
        console.error(Ex);
        //debugger;
        //throw Ex;  // we don't actually want to crash anything here
    }
}

function getBrandingData(currProfile, state) {
    if (currProfile?.memberships && currProfile.memberships.length > 0 && currProfile.memberships[0].branding) {
        let membershipBranding = {
            insuranceLogo: currProfile.memberships[0].branding.webLogo,
            insuranceLogoAltText: currProfile.memberships[0].branding.text,
            insuranceLogoClass: getInsuranceLogoClass(currProfile.memberships[0].membershipKey)
        };
        return membershipBranding;
    } else {
        return {
            insuranceLogo: state.membershipBranding.insuranceLogo,
            insuranceLogoAltText: state.membershipBranding.insuranceLogoAltText,
            insuranceLogoClass: state.membershipBranding.insuranceLogoClass
        };
    }
}

function getInsuranceLogoClass(membershipKey) {
    let logoClass = '';
    switch (membershipKey) {
        case membershipKeys.proto:
        case membershipKeys.default:
        case membershipKeys.swnt:
        case membershipKeys.swct:
            logoClass = 'hidden-logo';
            break;
        case membershipKeys.swhp:
        case membershipKeys.hrswhp:
            logoClass = 'swhp-logo';
            break;
        case membershipKeys.hrfc:
            logoClass = 'firstcare-logo';
            break;
        case membershipKeys.dart:
            logoClass = 'dart-logo';
            break;
        case membershipKeys.waco:
            logoClass = 'cow-logo';
            break;
        case membershipKeys.aa:
            logoClass = 'aal-logo';
            break;
        default: ''
    }
    return logoClass;
}


const membershipKeys = Object.freeze({
    proto: 'PROTO',
    default: 'DEFAULT',
    aa: 'AA',
    waco: 'WACO',
    dart: 'DART',
    swhp: 'SWHP',
    swnt: 'SWNT',
    hrswhp: 'HR-SWHP',
    hrfc: 'HR-FC',
    swct: 'SWCT',
});

function getStateFromFeatures(
    logins,
    currProfile) {

    if (logins == null) {
        return null;
    }

    try {
        const featureSDCVisit = tools.getFeature(currProfile, features.SDCVideoVisit);
        const featureAmbulatoryVisit = tools.getFeature(currProfile, features.AmbulatoryVideoVisit);
        const featureLyra = tools.getFeature(currProfile, features.Lyra);
        const featurePharmacy = tools.getFeature(currProfile, features.RXModule);
        const featureEVisit = tools.getFeature(currProfile, features.EVisit);
        const featureInsuranceModule = tools.getFeature(currProfile, features.InsuranceModule);
        const featureOnlineAppointmentScheduling = tools.getFeature(currProfile, features.OnlineAppointmentScheduling);
        const featureWellness = tools.getFeature(currProfile, features.Wellness);
        const featureChatBot = tools.getFeature(currProfile, features.ChatBot);
        const featureFluShot = tools.getFeature(currProfile, features.FluShot);
        const featureAmity = tools.getFeature(currProfile, features.Amity);
        const featureInHomeVaccine = tools.getFeature(currProfile, features.InHomeVaccine);
        const membershipDart = tools.getMembership(currProfile, membershipKeys.dart);
        const membershipWaco = tools.getMembership(currProfile, membershipKeys.waco);
        const membershipAA = tools.getMembership(currProfile, membershipKeys.aa);
        const membershipHRSWHP = tools.getMembership(currProfile, membershipKeys.hrswhp);
        const membershipAmiSWHP = tools.getMembership(currProfile, membershipKeys.swhp);
        const membershipFC = tools.getMembership(currProfile, membershipKeys.hrfc);

        const membershipSWNT = tools.getMembership(currProfile, membershipKeys.swnt);

        // var loginsHealthPlan = (logins.toLowerCase().indexOf("aal") !== -1) ||
        //     (logins.toLowerCase().indexOf("healthplan") !== -1) ||
        //     (logins.toLowerCase().indexOf("hr-fc") !== -1) ||
        //     (logins.toLowerCase().indexOf("hr-swhp") !== -1) ? true : false;

        // var SDCCostLabel = (logins.toLowerCase().indexOf("aal") !== -1) ? "$10" :
        //     (logins.toLowerCase().indexOf("hr-fc") !== -1) ? "standard office visit copay" :
        //         (logins.toLowerCase().indexOf("healthplan") !== -1) || (logins.toLowerCase().indexOf("hr-swhp") !== -1) ? "$0" :
        //             "standard office visit copay";

        var ActiveFeatures = {};
        currProfile.features.forEach((feature) => {
            if (feature) {
                if (feature.key.toLowerCase() === features.RXModule.toLowerCase()) {
                    if (feature.active) {
                        ActiveFeatures[feature.key] = feature.key;
                    }
                } else {
                    ActiveFeatures[feature.key] = feature.key;
                }
            }
        });

        return {
            //TODO: refactor this to be prettier

            isActiveFeature_SDCVideoVisit: featureSDCVisit ? true : false,
            SDCCostLabel: featureSDCVisit ? featureSDCVisit.costLabel : null,

            isActiveFeature_AmbulatoryVideoVisit: featureAmbulatoryVisit ? true : false,
            AmbulatoryCostLabel: featureAmbulatoryVisit ? featureAmbulatoryVisit.costLabel : null,

            hasPharmacyFeature: featurePharmacy ? true : false,
            isActiveFeature_Pharmacy: featurePharmacy && featurePharmacy.active ? true : false,

            isActiveFeature_EVisit: featureEVisit ? true : false,
            eVisitCostLabel: featureEVisit ? featureEVisit.costLabel : null,
            eVisitZipGroupId: featureEVisit?.zipGroupId,
            eVisitExternalId: tools.getPatientID(currProfile.patient.PatientIds, IDTypes.EXTERNAL),

            outOfStateOptionsForEVisit: featureEVisit && featureEVisit.outOfStateOptions,
            outOfStateOptionsForSdc: featureSDCVisit && featureSDCVisit.outOfStateOptions,

            isActiveFeature_InsuranceModule: featureInsuranceModule ? true : false,
            insuranceTabText: featureInsuranceModule?.tabText ?? "Deductible",  // just give us a default in case of tragedy

            hasAuthorizedFeatureSameDayVideo: currProfile?.patient?.HasAuthorizedFeature_SAMEDAYVIDEO || false,
            hasAuthorizedFeatureSchedCovidVax: currProfile?.patient?.HasAuthorizedFeature_SCHDCOVIDVAX || false,
            hasAuthorizedFeatureMyConditions: currProfile?.patient?.HasAuthorizedFeature_MYCONDITIONS || false,
            hasAuthorizedFeatureMedicalAdvice: currProfile?.patient?.HasAuthorizedFeature_MEDICALADVICE || false,

            isActiveFeature_OnlineAppointmentScheduling: !!featureOnlineAppointmentScheduling,

            isActiveFeature_Wellness: !!featureWellness,
            isActiveFeature_ChatBot: !!featureChatBot,
            isActiveFeature_FluShot: !!featureFluShot,

            isActiveFeature_InHomeVaccine: !!featureInHomeVaccine,
            inHomeVaccineCostLabel: featureInHomeVaccine?.costLabel || "Same As In Office",

            hasDART: membershipDart ? true : false,
            dartMembershipId: membershipDart?.memberId || '',
            hasWACO: membershipWaco ? true : false,
            wacoMembershipId: membershipWaco?.memberId || '',
            hasAA: membershipAA ? true : false,
            aaMembershipId: membershipAA?.memberId || '',
            hasFC: membershipFC ? true : false,
            fcMembershipId: membershipFC?.memberId || '',
            hasHRSWHP: membershipHRSWHP ? true : false,
            hrswhpMembershipId: membershipHRSWHP?.memberId || '',
            hasAmiSWHP: membershipAmiSWHP ? true : false,
            amiSWHPMembershipId: membershipAmiSWHP?.memberId || '',
            hasAnySWHP: membershipHRSWHP || membershipAmiSWHP ? true : false,
            anySWHPMembershipId: membershipHRSWHP?.memberId || membershipAmiSWHP?.memberId || '',

            // employee memberships
            employeeID: membershipSWNT?.employeeId || '',

            activeFeatures: ActiveFeatures,
            featureAmity,
            isActiveFeature_Lyra: featureLyra ? true : false,
            featureLyra
        };

    }
    catch (ex) {
        //debugger;
        console.error(ex);
        // returning a null object from this function is effectively a "no change" operation
    }
}
function getDefaultStateForFeatures() {
    return {
        //hasSDCVisitFeature: false,
        isActiveFeature_SDCVideoVisit: false,
        SDCCostLabel: null,

        //hasAmbulatoryVisitFeature: false,
        isActiveFeature_AmbulatoryVideoVisit: false,
        AmbulatoryCostLabel: null,

        hasPharmacyFeature: false,
        isActiveFeature_Pharmacy: false,

        //hasEVisitFeature: false,
        isActiveFeature_EVisit: false,
        eVisitCostLabel: null,
        eVisitZipGroupId: null,
        eVisitExternalId: null,

        outOfStateOptionsForEVisit: null,
        outOfStateOptionsForSdc: null,

        isActiveFeature_InsuranceModule: false,
        insuranceTabText: 'Deductible', //Most insurance plans use 'Deductible', only AA uses 'Usage'

        hasAuthorizedFeatureSameDayVideo: false,
        hasAuthorizedFeatureSchedCovidVax: false,
        hasAuthorizedFeatureMyConditions: false,
        hasAuthorizedFeatureMedicalAdvice: false,

        isActiveFeature_OnlineAppointmentScheduling: false,

        hasDART: false,
        dartMembershipId: '',
        hasWACO: false,
        wacoMembershipId: '',
        hasAA: false,
        aaMembershipId: '',
        hasFC: false,
        fcMembershipId: '',
        hasHRSWHP: false,
        hrswhpMembershipId: '',
        hasAmiSWHP: false,
        amiSWHPMembershipId: '',
        hasAnySWHP: false,
        anySWHPMembershipId: '',

        employeeID: '',

        activeFeatures: [],
        epicAuthorizedFeatures: null,
        enableCareCompanion: false
    }
}